import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Range } from '../../common/core/range.js';
import { OverviewRulerLane, MinimapPosition } from '../../common/model.js';
import { ModelDecorationOptions } from '../../common/model/textModel.js';
import { overviewRulerFindMatchForeground, minimapFindMatch } from '../../../platform/theme/common/colorRegistry.js';
import { themeColorFromId } from '../../../platform/theme/common/themeService.js';
export var FindDecorations = /*#__PURE__*/function () {
  function FindDecorations(editor) {
    _classCallCheck(this, FindDecorations);

    this._editor = editor;
    this._decorations = [];
    this._overviewRulerApproximateDecorations = [];
    this._findScopeDecorationIds = [];
    this._rangeHighlightDecorationId = null;
    this._highlightedDecorationId = null;
    this._startPosition = this._editor.getPosition();
  }

  _createClass(FindDecorations, [{
    key: "dispose",
    value: function dispose() {
      this._editor.deltaDecorations(this._allDecorations(), []);

      this._decorations = [];
      this._overviewRulerApproximateDecorations = [];
      this._findScopeDecorationIds = [];
      this._rangeHighlightDecorationId = null;
      this._highlightedDecorationId = null;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._decorations = [];
      this._overviewRulerApproximateDecorations = [];
      this._findScopeDecorationIds = [];
      this._rangeHighlightDecorationId = null;
      this._highlightedDecorationId = null;
    }
  }, {
    key: "getCount",
    value: function getCount() {
      return this._decorations.length;
    }
    /** @deprecated use getFindScopes to support multiple selections */

  }, {
    key: "getFindScope",
    value: function getFindScope() {
      if (this._findScopeDecorationIds[0]) {
        return this._editor.getModel().getDecorationRange(this._findScopeDecorationIds[0]);
      }

      return null;
    }
  }, {
    key: "getFindScopes",
    value: function getFindScopes() {
      var _this = this;

      if (this._findScopeDecorationIds.length) {
        var scopes = this._findScopeDecorationIds.map(function (findScopeDecorationId) {
          return _this._editor.getModel().getDecorationRange(findScopeDecorationId);
        }).filter(function (element) {
          return !!element;
        });

        if (scopes.length) {
          return scopes;
        }
      }

      return null;
    }
  }, {
    key: "getStartPosition",
    value: function getStartPosition() {
      return this._startPosition;
    }
  }, {
    key: "setStartPosition",
    value: function setStartPosition(newStartPosition) {
      this._startPosition = newStartPosition;
      this.setCurrentFindMatch(null);
    }
  }, {
    key: "_getDecorationIndex",
    value: function _getDecorationIndex(decorationId) {
      var index = this._decorations.indexOf(decorationId);

      if (index >= 0) {
        return index + 1;
      }

      return 1;
    }
  }, {
    key: "getCurrentMatchesPosition",
    value: function getCurrentMatchesPosition(desiredRange) {
      var candidates = this._editor.getModel().getDecorationsInRange(desiredRange);

      var _iterator = _createForOfIteratorHelper(candidates),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var candidate = _step.value;
          var candidateOpts = candidate.options;

          if (candidateOpts === FindDecorations._FIND_MATCH_DECORATION || candidateOpts === FindDecorations._CURRENT_FIND_MATCH_DECORATION) {
            return this._getDecorationIndex(candidate.id);
          }
        } // We don't know the current match position, so returns zero to show '?' in find widget

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return 0;
    }
  }, {
    key: "setCurrentFindMatch",
    value: function setCurrentFindMatch(nextMatch) {
      var _this2 = this;

      var newCurrentDecorationId = null;
      var matchPosition = 0;

      if (nextMatch) {
        for (var i = 0, len = this._decorations.length; i < len; i++) {
          var range = this._editor.getModel().getDecorationRange(this._decorations[i]);

          if (nextMatch.equalsRange(range)) {
            newCurrentDecorationId = this._decorations[i];
            matchPosition = i + 1;
            break;
          }
        }
      }

      if (this._highlightedDecorationId !== null || newCurrentDecorationId !== null) {
        this._editor.changeDecorations(function (changeAccessor) {
          if (_this2._highlightedDecorationId !== null) {
            changeAccessor.changeDecorationOptions(_this2._highlightedDecorationId, FindDecorations._FIND_MATCH_DECORATION);
            _this2._highlightedDecorationId = null;
          }

          if (newCurrentDecorationId !== null) {
            _this2._highlightedDecorationId = newCurrentDecorationId;
            changeAccessor.changeDecorationOptions(_this2._highlightedDecorationId, FindDecorations._CURRENT_FIND_MATCH_DECORATION);
          }

          if (_this2._rangeHighlightDecorationId !== null) {
            changeAccessor.removeDecoration(_this2._rangeHighlightDecorationId);
            _this2._rangeHighlightDecorationId = null;
          }

          if (newCurrentDecorationId !== null) {
            var rng = _this2._editor.getModel().getDecorationRange(newCurrentDecorationId);

            if (rng.startLineNumber !== rng.endLineNumber && rng.endColumn === 1) {
              var lineBeforeEnd = rng.endLineNumber - 1;

              var lineBeforeEndMaxColumn = _this2._editor.getModel().getLineMaxColumn(lineBeforeEnd);

              rng = new Range(rng.startLineNumber, rng.startColumn, lineBeforeEnd, lineBeforeEndMaxColumn);
            }

            _this2._rangeHighlightDecorationId = changeAccessor.addDecoration(rng, FindDecorations._RANGE_HIGHLIGHT_DECORATION);
          }
        });
      }

      return matchPosition;
    }
  }, {
    key: "set",
    value: function set(findMatches, findScopes) {
      var _this3 = this;

      this._editor.changeDecorations(function (accessor) {
        var findMatchesOptions = FindDecorations._FIND_MATCH_DECORATION;
        var newOverviewRulerApproximateDecorations = [];

        if (findMatches.length > 1000) {
          // we go into a mode where the overview ruler gets "approximate" decorations
          // the reason is that the overview ruler paints all the decorations in the file and we don't want to cause freezes
          findMatchesOptions = FindDecorations._FIND_MATCH_NO_OVERVIEW_DECORATION; // approximate a distance in lines where matches should be merged

          var lineCount = _this3._editor.getModel().getLineCount();

          var height = _this3._editor.getLayoutInfo().height;

          var approxPixelsPerLine = height / lineCount;
          var mergeLinesDelta = Math.max(2, Math.ceil(3 / approxPixelsPerLine)); // merge decorations as much as possible

          var prevStartLineNumber = findMatches[0].range.startLineNumber;
          var prevEndLineNumber = findMatches[0].range.endLineNumber;

          for (var i = 1, len = findMatches.length; i < len; i++) {
            var range = findMatches[i].range;

            if (prevEndLineNumber + mergeLinesDelta >= range.startLineNumber) {
              if (range.endLineNumber > prevEndLineNumber) {
                prevEndLineNumber = range.endLineNumber;
              }
            } else {
              newOverviewRulerApproximateDecorations.push({
                range: new Range(prevStartLineNumber, 1, prevEndLineNumber, 1),
                options: FindDecorations._FIND_MATCH_ONLY_OVERVIEW_DECORATION
              });
              prevStartLineNumber = range.startLineNumber;
              prevEndLineNumber = range.endLineNumber;
            }
          }

          newOverviewRulerApproximateDecorations.push({
            range: new Range(prevStartLineNumber, 1, prevEndLineNumber, 1),
            options: FindDecorations._FIND_MATCH_ONLY_OVERVIEW_DECORATION
          });
        } // Find matches


        var newFindMatchesDecorations = new Array(findMatches.length);

        for (var _i = 0, _len = findMatches.length; _i < _len; _i++) {
          newFindMatchesDecorations[_i] = {
            range: findMatches[_i].range,
            options: findMatchesOptions
          };
        }

        _this3._decorations = accessor.deltaDecorations(_this3._decorations, newFindMatchesDecorations); // Overview ruler approximate decorations

        _this3._overviewRulerApproximateDecorations = accessor.deltaDecorations(_this3._overviewRulerApproximateDecorations, newOverviewRulerApproximateDecorations); // Range highlight

        if (_this3._rangeHighlightDecorationId) {
          accessor.removeDecoration(_this3._rangeHighlightDecorationId);
          _this3._rangeHighlightDecorationId = null;
        } // Find scope


        if (_this3._findScopeDecorationIds.length) {
          _this3._findScopeDecorationIds.forEach(function (findScopeDecorationId) {
            return accessor.removeDecoration(findScopeDecorationId);
          });

          _this3._findScopeDecorationIds = [];
        }

        if (findScopes === null || findScopes === void 0 ? void 0 : findScopes.length) {
          _this3._findScopeDecorationIds = findScopes.map(function (findScope) {
            return accessor.addDecoration(findScope, FindDecorations._FIND_SCOPE_DECORATION);
          });
        }
      });
    }
  }, {
    key: "matchBeforePosition",
    value: function matchBeforePosition(position) {
      if (this._decorations.length === 0) {
        return null;
      }

      for (var i = this._decorations.length - 1; i >= 0; i--) {
        var decorationId = this._decorations[i];

        var r = this._editor.getModel().getDecorationRange(decorationId);

        if (!r || r.endLineNumber > position.lineNumber) {
          continue;
        }

        if (r.endLineNumber < position.lineNumber) {
          return r;
        }

        if (r.endColumn > position.column) {
          continue;
        }

        return r;
      }

      return this._editor.getModel().getDecorationRange(this._decorations[this._decorations.length - 1]);
    }
  }, {
    key: "matchAfterPosition",
    value: function matchAfterPosition(position) {
      if (this._decorations.length === 0) {
        return null;
      }

      for (var i = 0, len = this._decorations.length; i < len; i++) {
        var decorationId = this._decorations[i];

        var r = this._editor.getModel().getDecorationRange(decorationId);

        if (!r || r.startLineNumber < position.lineNumber) {
          continue;
        }

        if (r.startLineNumber > position.lineNumber) {
          return r;
        }

        if (r.startColumn < position.column) {
          continue;
        }

        return r;
      }

      return this._editor.getModel().getDecorationRange(this._decorations[0]);
    }
  }, {
    key: "_allDecorations",
    value: function _allDecorations() {
      var result = [];
      result = result.concat(this._decorations);
      result = result.concat(this._overviewRulerApproximateDecorations);

      if (this._findScopeDecorationIds.length) {
        var _result;

        (_result = result).push.apply(_result, _toConsumableArray(this._findScopeDecorationIds));
      }

      if (this._rangeHighlightDecorationId) {
        result.push(this._rangeHighlightDecorationId);
      }

      return result;
    }
  }]);

  return FindDecorations;
}();
FindDecorations._CURRENT_FIND_MATCH_DECORATION = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  zIndex: 13,
  className: 'currentFindMatch',
  showIfCollapsed: true,
  overviewRuler: {
    color: themeColorFromId(overviewRulerFindMatchForeground),
    position: OverviewRulerLane.Center
  },
  minimap: {
    color: themeColorFromId(minimapFindMatch),
    position: MinimapPosition.Inline
  }
});
FindDecorations._FIND_MATCH_DECORATION = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  className: 'findMatch',
  showIfCollapsed: true,
  overviewRuler: {
    color: themeColorFromId(overviewRulerFindMatchForeground),
    position: OverviewRulerLane.Center
  },
  minimap: {
    color: themeColorFromId(minimapFindMatch),
    position: MinimapPosition.Inline
  }
});
FindDecorations._FIND_MATCH_NO_OVERVIEW_DECORATION = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  className: 'findMatch',
  showIfCollapsed: true
});
FindDecorations._FIND_MATCH_ONLY_OVERVIEW_DECORATION = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  overviewRuler: {
    color: themeColorFromId(overviewRulerFindMatchForeground),
    position: OverviewRulerLane.Center
  }
});
FindDecorations._RANGE_HIGHLIGHT_DECORATION = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  className: 'rangeHighlight',
  isWholeLine: true
});
FindDecorations._FIND_SCOPE_DECORATION = ModelDecorationOptions.register({
  className: 'findScope',
  isWholeLine: true
});